const setModalType = (payload) => {
  return {
    type: "setModalType",
    payload,
  };
};

export default setModalType;
